export const ROLE_LABELS = {
    ROLE_ADMIN: "Administrator",
    ROLE_USER: "User",
    ROLE_COMPANY_ADMIN: "Company Admin",
    ROLE_COACH: "Coach"
};

type Role = keyof typeof ROLE_LABELS;

export const getRoleLabel = (role: Role): string => ROLE_LABELS[role] || "Unknown Role";

export const formatRoles = (roles: Role[]): string => roles.map(getRoleLabel).join(", ");
 
export const selectDataConverter = (
    data: any,
    labelKey: string,
    valueKey: string
  ): { label: string; value: any }[] => {
    if (!data || typeof data !== "object") {
      return [];
    }
  
    return Object.keys(data).map((key) => ({
      label: data[key][labelKey],
      value: data[key][valueKey],
    }));
  };


 export const formatDateToYYYYMMDDLocal =(date: Date) => {
    const year = date?.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Ensure 2 digits
    const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits
    return `${year}-${month}-${day}`;
  }
  

  export const mapBackendFiles = (documents: any[] | any) => {
    if (Array.isArray(documents)) {
      // If it's an array, map each document
      return documents.map((doc) => ({
        id: doc.id,
        path: doc.path,
        name: doc.file?.name || "Unknown",
        mime: doc.file?.mime || "application/octet-stream",
        nameOriginal: doc.file?.nameOriginal || "Unknown File",
        isExisting: true, // Mark as an existing file
        file: null, // No file object for existing files
      }));
    } else if (typeof documents === "object" && documents !== null) {
      console.log(documents,'documenta')
      // If it's a single object, wrap it in an array
      return {
          id: documents.id,
          path: documents.path,
          name: documents.file?.name || "Unknown",
          mime: documents.file?.mime || "application/octet-stream",
          nameOriginal: documents.file?.nameOriginal || "Unknown File",
          isExisting: true,
          file: null,
        }
      
    } else {
      // If it's neither an array nor an object, return an empty array
      return [];
    }
  };